import React, { useState } from "react"
import * as Constants from "../../../utils/constants"
import {
  Container,
  Input,
  Row,
  Col,
  Label,
  FormGroup,
  Button
} from 'design-react-kit';
import * as Validator from "../../../utils/validator"
import getBrowserName from "../../common/GetBrowserName";

export const SibaMostraSottoAlternative = ({ handleChoice, handleImportoChange, handleScadenzaChange, handleValiditaChange, handleBack, isAgevolazione}) => {

  const [localChoice, setLocalChoice] = useState('');
  const [importo, setImporto] = useState('');
  const [scadenza, setScadenza] = useState('');
  const [validita, setValidita] = useState(12);
 
  const [minValidita, setMinValidita] = useState(1);
  const [maxValidita, setMaxValidita] = useState(12);
 
   //STALIGK-887
  function changeValidReimmStorici() {
    setMinValidita(36);
    setMaxValidita(36);
    setValidita(36);
      
  }

  function resetValiditaDefault() {
    setMinValidita(1);
    setMaxValidita(12);
    setValidita(12);
    
  }

  const onImportoChanged = (event) => {
    console.log('importo', event.target.value)
    setImporto(event.target.value);
    handleImportoChange(Validator.getValidImportoOrEmptyValue(event.target.value));
  }

  const onScadenzaChanged = (event) => {
    //console.log('scadenza',event.target.value)
    setScadenza(event.target.value);
    handleScadenzaChange(Validator.getValidScadenzaOrEmptyValue(event.target.value));
  }

  const onValiditaChanged = (event) => {
    setValidita(event.target.value);
    //handleValiditaChange(Validator.isValidNumber(event.target.value) ? event.target.value : '');
    console.log("onValiditaChanged.setValidita:" + validita)
    handleValiditaChange(Validator.isMesiValiditàSottoAlternative(event.target.value,minValidita,maxValidita) ? event.target.value : '');
  }

  const onSubmit = () => handleChoice(localChoice);
  
  const onValueChange = (event) => {
      setLocalChoice(event.target.value)
      if(event.target.value == Constants.ALTRI_CASI_VEICOLI_STORICI) {
        changeValidReimmStorici();
        
      } else {
        resetValiditaDefault();
        
      }
  };

   // *** nuovi metodi x STALIGK-888 ***
   const browser = getBrowserName();

   const ScadenzaInputType = () => {
   //console.log(browser);

 if ((browser === "Firefox") || (browser === "Safari")) 
    return "text";
else 
    return "month";    
}

const ScadenzaPlaceHolder = () => {
if ((browser === "Firefox") || (browser === "Safari")) 
    return "Scadenza in formato AAAA-MM";
else 
    return "Scadenza in formato nome mese - anno";    
}
const ScadenzaInfoText = () => {
if ((browser === "Firefox") || (browser === "Safari")) 
    return "Digitare anno e mese in cui termina la validità (formato AAAA-MM)";
else 
    return "Selezionare dal calendario mese e anno in cui termina la validità";    
}


  let idLabelVeicoliStorici = Constants.ALTRI_CASI_VEICOLI_STORICI.replaceAll(" ","");
  let idLabelAltriCasiAfi = Constants.ALTRI_CASI_AFI.replaceAll(" ","");
  let idLabelEscurzionisti = Constants.ALTRI_CASI_ESCURSIONISTI_ESTERI.replaceAll(" ","");
  let idLabelAltriCasi = Constants.ALTRI_CASI_ALTRO.replaceAll(" ","");
  let idLabelCrisiFallimento = Constants.CRISI_FALLIMENTO.replaceAll(" ","");
 
  let ariaLabelVeicoliStorici = idLabelVeicoliStorici + "Description";
  let ariaLabelAltriCasiAfi = idLabelAltriCasiAfi + "Description";
  let ariaLabelEscurzionisti = idLabelEscurzionisti + "Description";
  let ariaLabelAltriCasi = idLabelAltriCasi + "Description";
  let ariaLabelCrisiFallimento = idLabelAltriCasi + "Description";


  function drawPagamentoAgevolazione(){
    if(isAgevolazione === true){
      return (<>
        <div className="form-check my-2" >
          <Input
            id={idLabelCrisiFallimento}
            value={Constants.CRISI_FALLIMENTO}
            bsSize="sm"
            type="radio"
            name="gruppo_alternative"
            onChange={onValueChange}
            defaultChecked={localChoice === Constants.CRISI_FALLIMENTO} />
          <Label for={Constants.CRISI_FALLIMENTO} tag="label" id={ariaLabelCrisiFallimento}>
            {Constants.RADIO_LABEL_CRISI_FALLIMENTO}
          </Label>  
        </div>
      </>)
    }
  }

  //START RENDERING
  return (
    <Container className="px-2 my-2" id="sottoAlternative" tag="section" >
      <h3>Ulteriori dati necessari</h3>
      <Container className="my-4" id="sottoAlternative1" tag="section" >
        <Row>
          <Col>
            <FormGroup className="my-2" >
              <Input
                id="inserisciImporto"
                infoText="Cifra in Euro da pagare (formato: cifre interi + . o , come separatore + 2 decimali)"
                label="Importo"
                placeholder="es. 15,00"
                value={importo}
                type="text"
                onChange={onImportoChanged}
                invalid={!Validator.isValidImporto(importo)}
                valid={Validator.isValidImporto(importo)}
              />
              <Input
                id="inserisciScadenza"
                //STALIGK-888 
                //infoText="Anno-Mese in cui termina la validità (aaaa-mm)"
                infoText={ScadenzaInfoText()}
                label="Valido fino al"
                //placeholder="scadenza in formato aaaa-mm"
                placeholder={ScadenzaPlaceHolder()}
                value={scadenza}
                type={ScadenzaInputType()}
                //type="month"
                //pattern={ScadenzaInputPattern()}
                onChange={onScadenzaChanged}
                invalid={!Validator.isValidAnnoMeseScadenza(scadenza,ScadenzaInputType())}
                valid={Validator.isValidAnnoMeseScadenza(scadenza,ScadenzaInputType())}
              />
              <Input
                id="inserisciValidita"
                infoText="Numero di mesi di validità (valore fisso 36 mesi per Reimm. Veicoli storici - massimo 12 mesi per altre categorie)"
                label="Durata in mesi"
                placeholder=""
                value={validita}
                type="number"
                min={minValidita}
                max={maxValidita}
                onChange={onValiditaChanged}
                invalid={!Validator.isMesiValiditàSottoAlternative(validita,minValidita,maxValidita)}
                valid={Validator.isMesiValiditàSottoAlternative(validita,minValidita,maxValidita)}
              />
            </FormGroup>
          </Col>
        </Row>
      </Container>
      <Container className="px-2 my-2 siba-align-left d-flex justify-content-around" id="sottoAlternative2" tag="section" >
        <Row>
          <Col>
            <h4>Sotto-categoria:</h4>
            <div className="form-check my-2" >
              <Input
                id={idLabelVeicoliStorici}
                value={Constants.ALTRI_CASI_VEICOLI_STORICI}
                bsSize="sm"
                type="radio"
                name="gruppo_alternative"
                onChange={onValueChange}
                defaultChecked={localChoice === Constants.ALTRI_CASI_VEICOLI_STORICI} />
              <Label for={Constants.ALTRI_CASI_VEICOLI_STORICI} tag="label" id={ariaLabelVeicoliStorici}>
                {Constants.RADIO_LABEL_REIMM_VEICOLI_STORICI}
              </Label>
            </div>
            <div className="form-check my-2" >
              <Input
                id={idLabelAltriCasiAfi}
                value={Constants.ALTRI_CASI_AFI}
                bsSize="sm"
                type="radio"
                name="gruppo_alternative"
                onChange={onValueChange}
                defaultChecked={localChoice === Constants.ALTRI_CASI_AFI} />
              <Label for={Constants.ALTRI_CASI_AFI} tag="label" id={ariaLabelAltriCasiAfi}>
              {Constants.RADIO_LABEL_ALTRI_CASI_AFI}
              </Label>
            </div>
            <div className="form-check my-2" >
              <Input
                id={idLabelEscurzionisti}
                value={Constants.ALTRI_CASI_ESCURSIONISTI_ESTERI}
                bsSize="sm"
                type="radio"
                name="gruppo_alternative"
                onChange={onValueChange}
                defaultChecked={localChoice === Constants.ALTRI_CASI_ESCURSIONISTI_ESTERI} />
              <Label for={Constants.ALTRI_CASI_ESCURSIONISTI_ESTERI} tag="label" id={ariaLabelEscurzionisti}>
              {Constants.RADIO_LABEL_ALTRI_CASI_EE}
              </Label>
            </div>
            <div className="form-check my-2" >
              <Input
                id={idLabelAltriCasi}
                value={Constants.ALTRI_CASI_ALTRO}
                bsSize="sm"
                type="radio"
                name="gruppo_alternative"
                onChange={onValueChange}
                defaultChecked={localChoice === Constants.ALTRI_CASI_ALTRO} />
              <Label for={Constants.ALTRI_CASI_ALTRO} tag="label" id={ariaLabelAltriCasi}>
                {Constants.RADIO_LABEL_ALTRI_CASI_ALTRO}
              </Label>
            </div>
            {drawPagamentoAgevolazione()}
          </Col>
        </Row>
      </Container>
      
      <Button className="btn btn-primary" color="primary" size="sm" icon={false} tag="button" onClick={onSubmit} disabled={!localChoice || !Validator.isValidImporto(importo) || !Validator.isValidData(scadenza) || !Validator.isMesiValiditàSottoAlternative(validita,minValidita,maxValidita) }>
        Conferma
      </Button>
    </Container>
  )
}

export default SibaMostraSottoAlternative;